var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50001 3.4837H6V4.48622H4.50001V5.98997H3.5V4.48622H2.00001V3.4837H3.5V1.97995H4.50001V3.4837ZM10 9.29123L9.29299 10L7.1715 7.87318L7.87851 7.16441L10 9.29123ZM4 7.01755C2.346 7.01755 1 5.66867 1 4.01003C1 2.35188 2.346 1.0025 4 1.0025C5.654 1.0025 7.00001 2.35188 7.00001 4.01003C7.00001 5.66867 5.654 7.01755 4 7.01755ZM4 0C1.791 0 0 1.79549 0 4.01003C0 6.22506 1.791 8.02005 4 8.02005C6.209 8.02005 7.99999 6.22506 7.99999 4.01003C7.99999 1.79549 6.209 0 4 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIcon);
export default __webpack_public_path__ + "static/media/zoom_in_icon.d750eed36a35d08ece57db68934adcca.svg";
export { ForwardRef as ReactComponent };